export default {
  wallet: {
    title: 'Porte-monnaie de Jetons',
    credits: 'jetons',
    availableCredits: 'Jetons disponibles',
    manage: 'Gérer les Jetons',
    purchase: 'Acheter des Jetons',
    processing: 'Traitement en cours...',
    save: 'Économiser',
    discount: 'Économisez',
    comparedToBase: 'vs forfait de base',
    comparedToPrevious: 'vs forfait précédent',
    viewHistory: "Voir l'Historique des Transactions",
    buyCredits: 'Acheter des Jetons',
    modalDescription: 'Achetez des jetons pour débloquer des fonctionnalités premium.',
    modalDescriptionFreelancer:
      'Achetez des jetons pour accepter des demandes de soumission et soumissionner sur des projets publics.',
    modalDescriptionRecruiter:
      'Achetez des jetons pour publier des projets et attirer des pigistes qualifiés.',
    selectPackage: 'Sélectionnez un forfait',
    noPackages: 'Aucun forfait de jetons disponible pour le moment.',
    paymentSuccessMessage:
      'Votre paiement a été effectué avec succès. Vos jetons ont été ajoutés à votre Porte-monnaie.',
    paymentFailedMessage: 'Le paiement a échoué. Veuillez réessayer.',
    retry: 'Réessayer',
  },
  credits: {
    insufficientTitle: 'Jetons Insuffisants',
    insufficientMessage:
      "Vous avez besoin de {{required}} jetons pour {{action}}, mais vous n'avez que {{current}} jetons.",
    required: 'Requis',
    current: 'Solde actuel',
    needed: 'Jetons nécessaires',
    buyCredits: 'Acheter des Jetons',
  },
  actions: {
    alliance_request: "envoyer une demande d'alliance",
    accept_quote_request: 'accepter cette demande de soumission',
    join_proposal: 'rejoindre cette proposition',
    submit_public_proposal: 'soumettre une proposition publique',
    post_public_job: 'publier un projet public',
  },
  packages: {
    starter: 'Pack Débutant',
    popular: 'Populaire',
    professional: 'Pack Professionnel',
    enterprise: 'Pack Entreprise',
  },
  history: {
    title: 'Historique des Transactions',
    date: 'Date',
    action: 'Action',
    amount: 'Montant',
    balance: 'Solde',
    noTransactions: 'Aucune transaction pour le moment',
    purchase: 'Achat de Jetons',
    consumption: 'jeton Utilisé',
  },
  costs: {
    alliance_request: '3 jetons (à partir de la 4e demande)',
    accept_quote_request: '5 jetons',
    join_proposal: '3 jetons',
    submit_public_proposal: '5 jetons',
    post_public_job: '10 jetons',
    free: 'Gratuit',
  },
};
